import Service from "../../../Services/index";

const payment = {
    namespaced: true,
    state: {
        paymentList :[],
        form:{
            name : "",
            date : "",
            vendor :"",
            amount_total : "",
            comment : "",
            user : ""
        },
        search:{
            name : "",
            vendor : "",
            date : "",
        },
        dataPaginate:{
            current_page :1,
            from : 1,
            last_page : 1,
            per_page : 1,
            total : 1,
            to : 1
        }
    },
    mutations: {
        GET_PAYMENT: (state, res) => {
            state.paymentList = res.data.map(payment=>({
                ...payment,
                show : 0
            }));
            state.dataPaginate = {
                current_page : res.current_page,
                from : res.form,
                last_page : res.last_page,
                per_page : res.per_page,
                total : res.total,
                to : res.to
            };
        },
        SET_FORM_DATA:(state,res)=>{
            state.form = res;
        },
        CLEAR_DATA :(state)=>{
            state.form = {
                name : "",
                date : "",
                vendor :"",
                amount_total : "",
                comment : "",
                user : ""
            }
        },
        CLEAR_SEARCH:(state)=>{
            state.search = {
                name : "",
                vendor : "",
                date : "",
            }
        },
    },
    actions: {
        setPayment({ commit },page=1) {
            return Service.PaymentPurchase.getPurchasePayment(page).then(response => {
                commit("GET_PAYMENT", response);
            });
        },
        savePayment({commit,state},id){
            let data = {
                name : state.form.name,
                date : state.form.date,
                vendor_id : "",
                amount_total : state.form.amount_total,
                comment : state.form.comment,
                user : state.form.user
            };
            if(state.form.vendor){
                data.vendor_id = state.form.vendor.id
            }
            console.log(data);
            if(!id){
                return Service.PaymentPurchase.createPurchasePayment(data);
            }else{
                return Service.PaymentPurchase.updatePurchasePayment(id,data);
            }
        },
        showPayment({commit},id){
            return Service.PaymentPurchase.showPurchasePayment(id).then(res=>{
                commit("SET_FORM_DATA",res)
            });
        },

        showDetails({commit},id){
            return Service.PaymentPurchase.showPaymentDetails(id);
        },

        deletePayment({commit},id){
            return Service.PaymentPurchase.deletePurchasePayment(id);
        },

        deletePaymentDetails({commit},id){
            return Service.PaymentPurchase.deletePurchasePaymentDetails(id);
        },
        savePaymentDetails({commit},{id,data}){
            console.log(id);
            console.log(data);
            if(!id){
                return Service.PaymentPurchase.createPurchasePaymentDetails(data);
            }else{
                return Service.PaymentPurchase.updatePurchasePaymentDetails(id,data);
            }
        },
        clearPayment({commit}){
            commit("CLEAR_DATA");
        },
        search({commit},data){
            return Service.PaymentPurchase.purchasePaymentSearch(data).then(response=>{
                commit("GET_PAYMENT", response);
            })
        },
        clearSearch({commit}){
            commit("CLEAR_SEARCH");
        }
    }
};

export default payment;
